import React from "react";
import { CommentLoadSection } from "./commentLoadSection";
import { DotSeprated } from "../comp-utils/UploadUtils";
import { humanReadableDate } from "../../utils/dateHelper";
import PropTypes from "prop-types";

function UserRequest() {
  return (
    <div className="flex-shrink-0 flex items-center">
      <svg
        className="w-[32px] h-[32px] sm:w-[40px] sm:h-[37px]"
        viewBox="0 0 40 37"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.1998 24.8008H27.7998V22.7508C27.7998 21.5841 27.0498 20.5924 25.5498 19.7758C24.0498 18.9591 22.1998 18.5508 19.9998 18.5508C17.7998 18.5508 15.9498 18.9591 14.4498 19.7758C12.9498 20.5924 12.1998 21.5841 12.1998 22.7508V24.8008ZM20.0103 16.4008C21.0033 16.4008 21.8498 16.0473 22.5498 15.3403C23.2498 14.6333 23.5998 13.7833 23.5998 12.7903C23.5998 11.7973 23.2463 10.9508 22.5393 10.2508C21.8323 9.55078 20.9823 9.20078 19.9893 9.20078C18.9963 9.20078 18.1498 9.55428 17.4498 10.2613C16.7498 10.9683 16.3998 11.8183 16.3998 12.8113C16.3998 13.8043 16.7533 14.6508 17.4603 15.3508C18.1673 16.0508 19.0173 16.4008 20.0103 16.4008ZM7.9998 32.0008L3.8558 36.1448C3.28514 36.7154 2.63314 36.8439 1.8998 36.5303C1.16647 36.2169 0.799805 35.6571 0.799805 34.8508V4.40078C0.799805 3.41078 1.1523 2.56328 1.8573 1.85828C2.5623 1.15328 3.4098 0.800781 4.3998 0.800781H35.5998C36.5898 0.800781 37.4373 1.15328 38.1423 1.85828C38.8473 2.56328 39.1998 3.41078 39.1998 4.40078V28.4008C39.1998 29.3908 38.8473 30.2383 38.1423 30.9433C37.4373 31.6483 36.5898 32.0008 35.5998 32.0008H7.9998ZM6.4998 28.4008H35.5998V4.40078H4.3998V30.5008L6.4998 28.4008Z"
          fill="#AD6800"
        />
      </svg>
    </div>
  );
}

export const ReasonSection = ({ title, createdOn, createdBy, comment }) => {
  return (
    <CommentLoadSection>
      <CommentLoadSection.Header>
        <div className="flex gap-5 ">
          <div className="flex-shrink-0 flex items-center">
            <UserRequest />
          </div>
          <div className="flex-1">
            <div className="semi-bold text-sm sm:text-base text-gray-900">
              {title}
            </div>
            <DotSeprated left={createdBy} right={createdOn} />
            <p className="hidden sm:block text-sm text-gray-800 mt-2 ">
              {comment}
            </p>
          </div>
          <div className="sm:hidden flex items-center justify-between">
            <CommentLoadSection.HeaderAction
              toggle
            ></CommentLoadSection.HeaderAction>
          </div>{" "}
        </div>
      </CommentLoadSection.Header>
      <div className="sm:hidden">
        <CommentLoadSection.Content>
          <p className=" text-[0.75rem] sm:text-sm text-gray-800 sm:mt-2 ml-[4.5rem] mr-[2rem]">
            {comment}
          </p>
        </CommentLoadSection.Content>
      </div>
    </CommentLoadSection>
  );
};

ReasonSection.propTypes = {
  title: PropTypes.string.isRequired,
  createdOn: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Date),
  ]).isRequired,
  createdBy: PropTypes.string.isRequired,
  comment: PropTypes.string,
};
